var translations = translations || {};

(function (translations) {
    'use strict';

    translations['pt'] = {
        //GENERICS
        'CLOSE': 'Fechar',
        'ERROR': 'Erro',
        'OK': 'Ok',
        'REMOVE': 'Eliminar',
        'CANCEL': 'Cancelar',
        'ON': 'Sim',
        'YES': 'Sim',
        'OFF': 'Não',
        'LOADING': 'A Carregar',
        'LOADING2': 'A Carregar dados...',
        'MORE_ELEMENTS': 'Mais elementos',
        'REQUIRED': 'Obrigatório',
        'HOME': 'Início',
        'POWERED_BY': 'Criado com',
        'HERE': 'aqui',
        'CORPORATE': 'www.upplication.com',

        //ERRORS
        'NETWORK_ERROR': 'Ups! Aparentemente há um erro. Tenta novamente ou contacta o teu administrador.',
        'CONTACT_CREATOR': 'Em caso de dúvidas contacta o teu administrador.',

        //NAV BAR
        //Langs
        'LANG': 'Idioma',
        'SPANISH': 'Espanhol',
        'ENGLISH': 'Inglês',
        'SUAJILI': 'Suaíli',

        //PWA advise
        'PWA.ICON': 'Adicionar à tela inicial',
        'PWA.ADD': 'Para instalar como um aplicativo, toque o ícone deste na barra do navegador e escolha: ',

        //ABOUT
        'ABOUT.INFO.WHO': 'Quem somos',
        'ABOUT.INFO.CONTACT': 'Contato',
        'ABOUT.INFO.LOCATION': 'Localização',
        'ABOUT.INFO.SOCIAL_NETWORK': 'Redes sociais',
        'ABOUT.INFO.POLICY' : 'Condições legais',

        //LOADERS
        'LOADER.APPLOAD.TEXT': 'A Carregar',
        'LOADER.APPUPDATE.TEXT': 'Atualizando a App!',

        //LOGIN STUFF
        'LOGIN.USER': 'Usuário',
        'LOGIN.EMAIL': 'Email',
        'LOGIN.NAME': 'Nome',
        'LOGIN.PHONE': 'Telefone',
        'LOGIN.SURNAME': 'Apelido',
        'LOGIN.DNI': 'DNI',
        'LOGIN.CAPTCHA': 'Captcha',
        'LOGIN.PASSWORD': 'Password',
        'LOGIN.PASSWORD.CONFIRM': 'Repetir Password',
        'LOGIN.REMEMBER': 'Lembrar',
        'LOGIN.SIGNIN': 'Iniciar sessão',
        'LOGIN.SIGNOUT': 'Fechar sessão',
        'LOGIN.GOTOLOGIN': 'Login',
        'LOGIN.FAIL.TITLE': 'Erro',
        'LOGIN.FAIL': 'Erro no usuário ou password.',
        'LOGIN.FAIL.MSG': 'As nossas desculpas mas o teu nome e password estão incorretas. Por favor, tenta novamente ou contata o teu administrador.',
        'LOGIN.NEEDED.TITLE': 'Atenção ! Primeiro precisas iniciar a sessão.',
        'LOGIN.NEEDED.MSG': 'Por favor, clica em LOGIN e inicia a sessão.',
        'LOGIN.RESTORE_PASSWORD': 'Não se lembras de tua password? Clica aqui',

        //COMMONS FOR REGISTER & ACCOUNT
        'LOGIN.ERR.VALIDATION': 'Informação incorreta:',
        'LOGIN.ERR.VALIDATION.MSG': 'Os campos marcados estão errados. Por favor, tenta novamente.',

        //ACCOUNT
        'LOGIN.ACCOUNT': 'A minha conta',
        'LOGIN.ACCOUNT.HEADER': 'A tua informação da conta',
        'LOGIN.ACCOUNT.UPDATE-ACCOUNT': 'Salvar',
        'LOGIN.ACCOUNT.DELETE-ACCOUNT': 'Eliminar conta',
        'LOGIN.ACCOUNT.OK': 'A tua informação foi salva',
        'LOGIN.ACCOUNT.ERR.SERVER': 'Erro ao guardar teus dados.',
        'LOGIN.ACCOUNT.ERR.SERVER.MSG.DEFAULT': 'Erro ao realizares o registo',

        'LOGIN.ACCOUNT.DELETE.MODAL.TITLE': 'Eliminar a conta',
        'LOGIN.ACCOUNT.DELETE.MODAL1.MSG': 'Depois de excluíres a tua conta, tu não a vais poder recuperar',
        'LOGIN.ACCOUNT.DELETE.MODAL2.MSG': 'Tens a certeza?, Tens envios pendentes, que os vais perder',
        'LOGIN.ACCOUNT.DELETE.MODAL.CONFIRM': 'Sim, eliminar',
        'LOGIN.HAVE_ACCOUNT': 'Não estás registado? Clica aqui',

        //REGISTER
        'LOGIN.REGISTER': 'Registo',
        'LOGIN.REGISTER.HEADER': 'Regista a tua nova conta!',
        'LOGIN.REGISTER.TERMS.TEXT': 'Aceito os',
        'LOGIN.REGISTER.TERMS.LINK': 'Termos e condições',
        'LOGIN.REGISTER.CREATE-ACCOUNT': 'Criar a minha conta',
        'LOGIN.REGISTER.OK': 'Já estás registado!',
        'LOGIN.REGISTER.OK.MSG': 'Nós vamos enviar um e-mail com um link de ativação para ativar a sua conta.',
        'LOGIN.REGISTER.ERR.SERVER': 'Erro ao registar.',
        'LOGIN.REGISTER.ERR.SERVER.MSG.DUPLICATED-EMAIL': 'Este email já está a ser utilizado',
        'LOGIN.REGISTER.ERR.SERVER.MSG.DEFAULT': 'Ocorreu um erro ao processar o seu registo',
        'LOGIN.REGISTER.SUCCESS.MSG': 'Estás corretamente registado.',

        //ACTIVATE
        'LOGIN.ACTIVATE.HEADER': 'Ativar a minha conta',
        'LOGIN.ACTIVATE.TEXT': 'Enviamos um email com um código de 4 dígitos para que ative a sua conta.',
        'LOGIN.REGISTER.RESEND-ACTIVATE-ACCOUNT': 'Se não recebeu nenhum email, clica aqui para enviar outra vez.',
        'LOGIN.REGISTER.ACTIVATE-ACCOUNT': '¡Ativar!',
        'LOGIN.ACTIVATE.ERR.SERVER': 'Error trying to activate the user',
        'LOGIN.RESEND.ACTIVATE.ERR.SERVER': 'Error trying to send the activation email',

        //CART (module)
        'ADDRESS.NAME': 'Rua',
        'ADDRESS.POSTAL-CODE': 'Código Postal',
        'ADDRESS.CITY': 'Cidade',
        'ADDRESS.STATE': 'Província',
        'ADDRESS.COUNTRY': 'País',
        'ADDRESS.CIF' : 'NIF',
        'ADDRESS.PHONE' : 'Telefone',
        'ADDRESS.PERSON' : 'Sou um individuo',
        'ADDRESS.BUSINESS' : 'Sou uma empresa',
        'ADDRESS.VAT' : 'VAT ID',
        'ADDRESS.DNI' : 'DNI',
        'ADDRESS.NIF' : 'NIF',
        'ADDRESS.ADDRESSEE' : 'Destinatário',
        'ADDRESS.BUSINESS_NAME' : 'Razão Social',

        //CATALOG (module)
        'CATALOG.PRODUCTS.SHOW.BTN.BLOCK' : 'Mostrar em bloco',
        'CATALOG.PRODUCTS.SHOW.BTN.INLINE' : 'Mostrar em linha',

        //BANNER
        'FCMPLUGIN.BANNER' : 'Estamos finalizando a sincronização de tua app, aguarde alguns segundos...',

        // ORDERS
        'MY-ORDERS.MENU': 'Pedidos',
        'MY-ORDERS.TITLE': 'Pedidos',
        'MY-ORDERS.DATE': 'Data',
        'MY-ORDERS.PRICE': 'Preço',
        'MY-ORDERS.SENT': 'Enviado',

        'MY-ORDERS.SHIPPING': 'Endereço de entrega',
        'MY-ORDERS.BILLING': 'Endereço de faturação',
        'MY-ORDERS.OBSERVATIONS': 'Observações',

        'MY-ORDERS.AMOUNT': 'Quantidade',
        'MY-ORDERS.PRODUCT': 'Produto',
        'MY-ORDERS.SIZE': 'Tamanho',
        'MY-ORDERS.COLOR': 'Cor',
        'MY-ORDERS.UNIT-PRICE': 'Preço',
        'MY-ORDERS.TOTAL-PRICE': 'Total',
        'MY-ORDERS.SHIPPING-CHARGES': 'Portes de Envio',
        'MY-ORDERS.PAYMENT_METHOD': 'Método de pagamento',
        'MY-ORDERS.PAID_WITH_PAYPAL': 'Pagamento com PayPal',
        'MY-ORDERS.PAID_WITH_REDSYS': 'Pagamento com Cartão de crédito',
        'MY-ORDERS.PAY_ON_DELIVERY': 'Pagamento em dinheiro contra entrega',
        'MY-ORDERS.PAY_WIRE_TRANSFER': 'Pagamento por transferência',
        'MY-ORDERS.PAY_AT_STORE': 'Pagamento na loja',
        'MY-ORDERS.NO-ORDER': 'Não há nenhum pedido',

        // RESTORE
        'RESTORE.TITLE': 'Recuperar senha',
        'RESTORE.FAIL.MSG': 'Não foi possível encontrar um utilizador associado ao email introduzido. Tenta novamente.',
        'RESTORE.FAIL': 'Erro',
        'RESTORE.EMAIL': 'Introduz o teu Email',
        'RESTORE.EMAIL.SAMPLE': 'E.j.: pepe@gmail.com',
        'RESTORE.SUBMIT': 'Restaurar',
        'RESTORE.SUCCESS.MSG': 'Um e-mail foi enviado para a tua conta para que possas recuperar tua senha.',

        // CHANGE PASSWORD
        'CHANGE_PASSWORD.BTN': 'Modificar senha',
        'CHANGE_PASSWORD.TITLE': 'Nova senha',
        'CHANGE_PASSWORD.FAIL.MSG': 'Ocorreu um erro, não podemos alterar a sua senha',
        'CHANGE_PASSWORD.FAIL': 'Erro',
        'CHANGE_PASSWORD.PASSWORD': 'Senha',
        'CHANGE_PASSWORD.PASSWORD_REPEAT': 'Repetir senha',
        'CHANGE_PASSWORD.SUBMIT': 'Modificar senha',
        'CHANGE_PASSWORD.SUCCESS.MSG': 'A tua senha foi alterada com sucesso..',

        //HTTP ERRORS CODES
        'HTTP.ERROR.childupp.not-exists': 'The website is unavailable.',
        'HTTP.ERROR.childupp.out-of-service': 'The website is unavailable.',
        'HTTP.ERROR.childupp.trial.expired': 'The website is temporarily unavailable.',
        'HTTP.ERROR.payment.blocked': 'The website is temporarily unavailable.',
        'HTTP.ERROR.user.email.in-use': 'Indicated email address has already been registered.',
        'HTTP.ERROR.user.code.not-valid': 'The activation code is invalid',
        'HTTP.ERROR.user.not-exists': 'The user not exists',
        // FIXME: translate or remove (maybe not have sense to send this info from the server side)
        'HTTP.ERROR.user.childupp.not-match': 'translate!!',
        'HTTP.ERROR.product.not-found': 'translate!!',
        'HTTP.ERROR.empty.basket': 'translate!!',
        'HTTP.ERROR.shippingcharges.not-found': 'translate!!',
        'HTTP.ERROR.user.data.incomplete': 'translate!!',
        'HTTP.ERROR.user.status.waiting': 'translate!!',
        'HTTP.ERROR.payment.data.not-found': 'translate!!',
        'HTTP.ERROR.order.not-exists': 'translate!!',
        'HTTP.ERROR.order.childupp.not-match': 'translate!!',
        'HTTP.ERROR.order.not-waiting': 'translate!!',
        'HTTP.ERROR.catalog.contact-info.not-found': 'translate!!',
        'HTTP.ERROR.catalog.promotion.not-found': 'translate!!',
        'HTTP.ERROR.catalog.category.not-found': 'translate!!',
        'HTTP.ERROR.DEFAULT' : 'There has been an error processing your request. Please try again or contact your administrator.'
    };

})(window.translations);



// WEBPACK FOOTER //
// ./src/app/common/lang/lang_pt.js